const BASE_URL = 'https://project-auth-backend-api.herokuapp.com';
// const BASE_URL = 'http://localhost:8080'

export const API_URL = (slug) => `${BASE_URL}/${slug}`;